import treatments from "../../../fakeApi/treatments";
const state = { treatments: [] };

const getters = {
  allTreatments: state => state.treatments.data
};
const actions = {
  async fetchTreatments({ commit }) {
    commit("setTreatments", treatments);
  }
};

const mutations = {
  setTreatments: (state, treatments) => (state.treatments = treatments)
};

export default {
  state,
  getters,
  actions,
  mutations
};
